import initialState from './initial.state';
import * as types from '../actions/types.action';

/**
 * Peer-gap trial cards returned alongside the search results.
 *
 * Deliberately not folded into search.reducer: those results are appended to on every
 * infinite-scroll page, whereas featured items only ever arrive with page 0 and must be replaced
 * wholesale on a new search rather than accumulated.
 *
 * The server-side render dispatches the same GET_SEARCH_RESULTS_SUCCESS without featuredResults,
 * so a server-rendered page starts with none — which is what we want, since these cards are
 * account-specific and the SSR HTML is cacheable. SearchPage re-runs the search on mount, and the
 * client-side response fills them in.
 */
export default function featuredResultsReducer(
  state = initialState.featuredResults,
  action
) {
  switch (action.type) {
    case types.GET_SEARCH_RESULTS_SUCCESS:
      return action.featuredResults || [];
    case types.GET_SEARCH_RESULTS_REQUESTED:
    case types.GET_SEARCH_RESULTS_FAILED:
      return [];
    default:
      return state;
  }
}
